import MuiListItem, { ListItemProps as MuiListItemProps } from '@mui/material/ListItem';
import { ComponentType, forwardRef } from 'react';
import Pane, { PaneProps } from '../Pane';
import { styled } from '@mui/material/styles';
import colors from '../theme/colors';
import { MarginProps, PaddingProps } from '@mui/system';

export interface ListItemProps extends MuiListItemProps, PaddingProps, MarginProps {
  /**
   * Choose default MUI behavior or O2Pane wrapper for ListItem component.
   */
  variant?: 'default' | 'pane';
  /**
   * Props applied to the Pane element if variant="pane".
   */
  paneProps?: PaneProps;
  /**
   * Enable/disable the bottom progress bar.
   */
  progress?: number;
  /**
   * Color of the bottom progress bar.
   */
  progressColor?: 'default' | 'error';

  /**
   * Render as clickable button.
   */
  button?: boolean;

  component?: ComponentType<any>;
}

const ListItemProgress = styled('div', {
  name: 'ListItem',
  slot: 'Progress',
  shouldForwardProp: (prop) => prop !== 'ownerState',
})<any>(({ ownerState }) => ({
  width: `${ownerState.progress}%`,
  height: '8px',
  background: `${ownerState.progressColor === 'error' ? colors.error[500] : colors.brandPrimary[400]}`,
  position: 'absolute',
  bottom: -2,
  left: 0,
}));

const ListItem = forwardRef<HTMLLIElement, ListItemProps>((props, ref) => {
  const { variant = 'default', progress, progressColor = 'default', paneProps, ...other } = props;
  const ownerStateProgress = {
    progress,
    progressColor,
  };

  return variant === 'pane' ? (
    <Pane variant="outlined" p={2} {...paneProps}>
      <MuiListItem ref={ref} {...other} sx={{ padding: 0 }} {...({ variant } as any)} />
      <ListItemProgress ownerState={ownerStateProgress} />
    </Pane>
  ) : (
    <MuiListItem {...({ variant } as any)} ref={ref} {...other} />
  );
});

ListItem.displayName = 'ListItem';

export default ListItem;
